import { createSlice } from '@reduxjs/toolkit';
import { BestAvailableText } from '../interfaces/types';

const initialState: BestAvailableText = (window as any).pageData ? (window as any).pageData : null;

const bestAvailableTextSlice = createSlice({
    name: 'best-available-text-slice',
    initialState,
    reducers: {
    },
})

export default bestAvailableTextSlice;